import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><linearGradient id=\"gemini-spark-gradient\" x1=\"3\" x2=\"21\" y1=\"4\" y2=\"20\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#4285F4\"></stop><stop offset=\".5\" stop-color=\"#9B72CB\"></stop><stop offset=\"1\" stop-color=\"#D96570\"></stop></linearGradient></defs><path fill=\"url(#gemini-spark-gradient)\" d=\"M12 1q0 11 11 11-11 0-11 11 0-11-11-11 11 0 11-11\"></path>", 2)
  ]))]))
}
export default { render: render }